/**
 * @generated SignedSource<<9cfbd9e95628fb20033c6c903a09005c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "offset"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "orderBy"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "orderDirection"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "resellerName"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "vendorAccountId"
},
v6 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "first",
        "variableName": "first"
      },
      {
        "kind": "Variable",
        "name": "offset",
        "variableName": "offset"
      },
      {
        "kind": "Variable",
        "name": "orderby",
        "variableName": "orderBy"
      },
      {
        "kind": "Variable",
        "name": "orderdirection",
        "variableName": "orderDirection"
      },
      {
        "kind": "Variable",
        "name": "resellername",
        "variableName": "resellerName"
      },
      {
        "kind": "Variable",
        "name": "vendoraccountid",
        "variableName": "vendorAccountId"
      }
    ],
    "concreteType": "AdminVendorSummaryResultsConnection",
    "kind": "LinkedField",
    "name": "adminvendorsummarywithorderby",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "totalCount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "AdminVendorSummaryResult",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "resellerAccountName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "resellerAccountId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "registeredReseller",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "appName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "subscriptionCount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalCharge",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "averageCharge",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "AdminVendorSummaryQuery",
    "selections": (v6/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v5/*: any*/),
      (v4/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "AdminVendorSummaryQuery",
    "selections": (v6/*: any*/)
  },
  "params": {
    "cacheID": "4f084b4fdbe1315d1b10ab692af1a46c",
    "id": null,
    "metadata": {},
    "name": "AdminVendorSummaryQuery",
    "operationKind": "query",
    "text": "query AdminVendorSummaryQuery(\n  $vendorAccountId: UUID!\n  $resellerName: String\n  $orderBy: Int\n  $orderDirection: Int\n  $first: Int\n  $offset: Int\n) {\n  adminvendorsummarywithorderby(vendoraccountid: $vendorAccountId, resellername: $resellerName, orderby: $orderBy, orderdirection: $orderDirection, first: $first, offset: $offset) {\n    totalCount\n    nodes {\n      resellerAccountName\n      resellerAccountId\n      registeredReseller\n      appName\n      subscriptionCount\n      totalCharge\n      averageCharge\n    }\n  }\n}\n"
  }
};
})();

node.hash = "471742fea3fee9f435c8ea7ea9e88cd9";

module.exports = node;
